// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"155":"07bf8c5a","314":"ad053ff1","422":"55a051f5","670":"afc9f640","869":"c45f7af0"}[chunkId] + ".chunk.js";
};